import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EidosConfigService } from '../config/eidos-config.service';
import { CoreFormatService } from './core-format.service';
import { EidosBaseApiService } from './eidos-base-api.service';
import { EidosLogService } from './eidos-log.service';
import { EidosSecurityService } from './eidos-security.service';

@Injectable({
  providedIn: 'root'
})
export class EidosEntityService extends EidosBaseApiService {
  constructor(
    public coreFormatService: CoreFormatService,
    public configService: EidosConfigService,
    public eidosLogService: EidosLogService,
    public eidosSecurityService: EidosSecurityService,
    public http: HttpClient
  ) {
    super(coreFormatService, configService, eidosLogService, eidosSecurityService, http);
  }
}
